import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import jwt from 'jsonwebtoken'
import router from '@/router'

// var baseURL = process.env.VUE_APP_BASE_URL
  var axios = Axios.create({
       baseURL: process.env.VUE_APP_BASE_URL
  })

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authStatus: '',
    sendStatus:'',
    token: localStorage.getItem('token') || '',
    isMobile: false,
    deviceSize: 0,
  },
  getters: {
    authorized: state => !!state.token,
    authstatus: state => state.authStatus,
    isMobile: state => state.deviceSize < 768
  },
  mutations: {
    auth_request (state) {
     state.authStatus = 'loading'
    },
    sending (state) {
        state.sendStatus = 'sending'
       },
    getting (state) {
        state.sendStatus = 'getting'
     },
    auth_success (state, { token}) {
      state.authStatus = 'success'
      state.token = token
    },
    auth_error (state) {
      state.authStatus = 'error'
    },
    resize (state, deviceSize){
      state.deviceSize = deviceSize;
    },
    logout (state) {
      state.authStatus = ''
      state.token = ''
    }
  },
  actions: {
    login ({ commit }, userData) {
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios.post('/login', { username: userData.username, password: userData.password })
            .then(response => {
              const token = response.data.access_token
              const refreshToken = response.data.refresh_token;
              const decoded = jwt.decode(token);
              const name = decoded.name
              const permission = decoded.permissions
              localStorage.setItem('permission', permission)
              // storing jwt in localStorage. https cookie is safer place to store
              localStorage.setItem('name', name)
              localStorage.setItem('permission', permission)
              localStorage.setItem('token', token)
              localStorage.setItem('refreshToken', refreshToken)
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              // mutation to change state properties to the values passed along
              commit('auth_success', {token})
              resolve(response)
            })
            .catch(err => {
              console.log(err)

              commit('auth_error')
              localStorage.removeItem('token')
              reject(err)
            })
        })
  },
  updatePbnPermissions ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('sending')
      console.log(localStorage.getItem('token'))
      axios.post('/users/enable_pbn/'+userData.user_id, { current_value: userData.current_value }, {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') } })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
},
  addSite ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('sending')
      console.log(localStorage.getItem('token'))
      axios.post('/domains', { domainName: userData.domainName, wordpressUser: userData.wordpressUser, wordpressPassword: userData.wordpressPassword, 
        type:userData.type, market:userData.market, copyFromDomain: userData.copyFromDomain, controlSend: userData.controlSend, 
        beasttrackSend: userData.beasttrackSend, backlySend: userData.backlySend, leadsSend: userData.leadsSend, 
        aifarmSend: userData.aifarmSend },
         {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') } })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getDomains () {
    return new Promise((resolve, reject) => {
      axios.get('/domains', {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
},
getMarkets () {
  return new Promise((resolve, reject) => {
    axios.get('/markets', {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log(err)
        reject(err)
      })
  })
},
getUsers () {
  return new Promise((resolve, reject) => {
    axios.get('/users/', {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log(err)
        reject(err)
      })
  })
},
getLanguages () {
  return new Promise((resolve, reject) => {
    axios.get('/translate/languages/', {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log(err)
        reject(err)
      })
  })
},
postContent ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.post('/domains/post?contentId='+userData.contentId+'&domain='+userData.domain,{content: userData.content, title: userData.title, type: userData.type , translate: userData.translate, src_language: userData.src_language , to_language: userData.to_language} ,{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
deletePost({commit},userData){
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.delete('/posts/'+userData.contentId,{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
getPosts () {
  return new Promise((resolve, reject) => {
    axios.get('/posts',{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
getPostData ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.get('/posts?contentId='+userData.contentId,{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
saveContent ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.post('/domains/post/save?contentId='+userData.contentId+'&domain='+userData.domain,{content: userData.content, title: userData.title, type: userData.type , translate: userData.translate, src_language: userData.src_language , to_language: userData.to_language} ,{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
translateContent ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.post('/domains/post/translate',{content: userData.content, title: userData.title, translate: userData.translate, src_language: userData.src_language , to_language: userData.to_language} ,{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
getPostTypes ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {  
    axios.get('/domains/post_types?domain='+userData.domain, {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
aiPrompt ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {  
    axios.post('/ai_prompt',{words: userData.words,language:userData.language,keyword:userData.keyword,secondary_keywords: userData.secondary_keywords,subject:userData.subject},{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
aiDetect ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {  
    axios.post('/ai/detect',{content: userData.content},{headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},
loginDomain ( { commit }, userData) {
  commit("getting")
  return new Promise((resolve, reject) => {
    axios.get('/domains/login?domain='+userData.domain, {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
},

  logout ({ commit }) {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('name')
      localStorage.removeItem('refreshToken')
      delete axios.defaults.headers.common['Authorization']
      router.push('/login')
      resolve()
    })
  },
  refreshToken ({ commit }) {
    return axios.get('refreshToken', {headers: {'Authorization': "bearer " + localStorage.getItem('refreshToken')}})
      .then(response => {
        const token = response.data.access_token
        const decoded = jwt.decode(token);
        const name = decoded.name
        const permission = decoded.permissions
        localStorage.setItem('permission', permission)
        if(permission == "finance"){
          this.state.isFinance = true
        }
        localStorage.setItem('token', token)
        localStorage.setItem('name', name)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      })
      .catch(() => {
        commit('logout')
        localStorage.removeItem('token')
        router.push('/');
      })
  },
  getCredentials ( { commit }, userData) {
    commit("getting")
    return new Promise((resolve, reject) => {
      axios.get('/credentials/'+userData.credentialId, {headers: {'Authorization' : 'Bearer ' + localStorage.getItem('token') }})
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  }
})
